module.exports = __webpack_public_path__ + "img/task.ba0c117c.png";